import React from 'react';
import { AppRouter } from './AppRouter';
export function App() {
  return <AppRouter data-id="element-0" />;
}